import * as React from "react";
import { UpdatedActiveState } from ".";
import styled from "styled-components";

interface Props {
  customers: UpdatedActiveState[];
}

const UpdatedActiveCustomerList = ({ customers }: Props) => {
  return (
    <div>
      {!customers.length && <p>Inga kunder med ny aktiv status hittades.</p>}
      {customers.length > 0 && (
        <table className="table-small dataTable dtr-inline">
          <thead>
            <tr>
              <td>Kund</td>
              <td>Aktiv</td>
            </tr>
          </thead>
          <tbody>
            {customers.map((customer) => (
              <tr key={customer.customerNo}>
                <td>{customer.name}</td>
                <td>{customer.active ? "Ja" : "Nej"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UpdatedActiveCustomerList;
